export async function appointmentSetStatusUseCase(id, data, appointmentRepostitory) {
    const result = await appointmentRepostitory.set_status(id, data);
    
    return result;
}